
export class TotalInfo<T> {
  constructor(
    public totalItems?: number,
    public items?: T[]
  ) {
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/total-info.ts